export default {
    bot_description: "Описание бота",
    bot_name: "Имя бота",
    clinic_account: "Аккаунт клиники",
    clinic_site_link: "Ссылка на сайт клиники",
    code_for_bonus_payment: "Код для оплаты бонусами",
    code_was_not_sent: "Код не был отправлен - пациенту нужно проверить подключение к телеграм боту",
    code_was_sent_to_patient_through_bot: "Код был отправлен пациенту через телеграм бота",
    connected_to_telegram_bot: "Подключен к телеграм боту",
    max_bot: "Max bot",
    telegram_bot: "Telegram bot",
    telegram_bot_default_description: "Бот помогает пациентам клиники накапливать бонусы и получать актуальную информацию о визитах",
    telegram_bot_instruction_1: "Откройте мессенджер Telegram, войдите в вашу учетную запись или создайте новую. Введите в поле поиска <code>{'@'}BotFather</code> и выберите бот",
    telegram_bot_instruction_2: "Выберите или напечатайте и отправьте команду <code>/newbot</code>",
    telegram_bot_instruction_3: "Дайте имя боту — клиенты увидят это имя при общении с ботом. И никнейм бота — по нему можно будет найти бота в Telegram. Никнейм должен быть уникальным, не повторять существующие в базе и заканчиваться на слово bot",
    telegram_bot_instruction_4: "Скопируйте значение токена у созданного бота, вставьте в поле ниже и сохраните",
    use_bonuses_by_confirming_through_telegram_bot: "Списание бонусов с подтверждением через Телеграм бота",
    wrong_code: "Код неверный"
}
